import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { IMessage } from "../models";

// Toast/snackbar messages live in their own slice. They used to sit on the
// appUser slice, which meant every toast produced a new appUser object and
// re-rendered every component subscribed to that slice (including the theme
// provider, which rebuilt the whole MUI theme).
export interface MessageState {
  message: IMessage | null;
}

const initialState: MessageState = {
  message: null,
};

export const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    setMessage: (state, action: PayloadAction<IMessage | null>) => {
      state.message = action.payload;
    },
  },
});

export const { setMessage } = messageSlice.actions;

export default messageSlice.reducer;
